import { combineReducers } from "redux"
import customizer from "./customizer/"
import auth from "./auth/"
import navbar from "./navbar/Index"
import organizationList from "./organization"
import masterApiReducer from "./masterData"
import settingsReducer from "./settings"
import todoReducer from "./todo"

const rootReducer = combineReducers({
  customizer: customizer,
  auth: auth,
  navbar: navbar,
  todoApp: todoReducer,
  organizationList: organizationList,
  masterApiData: masterApiReducer,
  settingsData: settingsReducer
})

export default rootReducer
